import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { firstValueFrom } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-success',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.scss',
})
export class PaymentSuccessComponent {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    setTimeout(async () => {
      const newUser = await firstValueFrom(this.authService.forceUpdateUser());
      this.redirect();
    }, 5000);
  }

  redirect() {
    this.router.navigate(['']);
  }
}
